














import Vue from 'vue'

import Localized from '@/components/Localized'

export default Vue.extend({
  components: { Localized },
  computed: {
    isEmpty(): boolean {
      return !this.value[this.variable]
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [String, Object],
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      required: true,
      type: Object,
    },
    variable: {
      required: true,
      type: String,
    },
  },
})
